import { render, staticRenderFns } from "./MenuGroupResults.vue?vue&type=template&id=7815b25f&scoped=true"
import script from "./MenuGroupResults.vue?vue&type=script&lang=ts"
export * from "./MenuGroupResults.vue?vue&type=script&lang=ts"
import style0 from "./MenuGroupResults.vue?vue&type=style&index=0&id=7815b25f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7815b25f",
  null
  
)

export default component.exports